<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="6">
                <ValidatableTextField v-model:form="form" label="Name" :field="'name'" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import { type IOwner } from '@app/land-hold/owner/models/Owner.ts';
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import { useOwnerRepository } from '@app/land-hold/owner/repositories/useOwnerRepository';

const props = defineProps({
    item: {
        type: Object as PropType<IOwner>,
        required: true,
    },
});

const update = useOwnerRepository().command.update(props.item.id, props.item);
const form = update.form;
useInjectSubmitForm(update.execute);
</script>
